import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CloseIcon, IconButton } from '@okcredit/web-lib'
import { Popup } from 'components/Popup'
import { IDashboardState } from 'state/dashboard/dashboard.types'
import { IAppState } from 'infra/AppState'
import { selectBusinessAccountAction } from 'state/dashboard/dashboard.actions'
import { resolveImageUrl } from 'utils/imageUrl'
import BusinessListItem from './components/BusinessListItem'
import SelectAccountModalStyles from './SelectAccountModal.styles'

export const SelectAccountModal: React.FC<{
  onClose: () => void
}> = ({ onClose }) => {
  const classes = SelectAccountModalStyles()
  const dispatch = useDispatch()
  const dashboardState: IDashboardState = useSelector((app: IAppState) => app.Dashboard)
  const { businessAccounts } = dashboardState

  const handleOnSelection = (businessId: string, isAdmin: boolean) => () => {
    dispatch(selectBusinessAccountAction({ businessId, isAdmin }))
  }

  return (
    <Popup noPadding={true}>
      <div className={classes.container}>
        <div className={classes.header} onClick={onClose}>
          <div>Multiple Accounts</div>
          <IconButton className={classes.closeBtn} onClick={onClose} size="medium">
            <CloseIcon size={20} />
          </IconButton>
        </div>
        <div className={classes.content}>
          {businessAccounts?.asStaffBusinessIds
            .filter((businessId) => Boolean(businessAccounts?.asStaffBusinessDetails?.[businessId]))
            .map((businessId) => {
              const user = businessAccounts?.asStaffBusinessDetails?.[businessId]
              return (
                <BusinessListItem
                  key={businessId}
                  id={businessId}
                  isAdmin={false}
                  name={user?.name || ''}
                  avatar={resolveImageUrl(user?.profileImage, { width: 40 })}
                  onClick={handleOnSelection(businessId, false)}
                />
              )
            })}
          {businessAccounts?.businessIds
            .filter((businessId) => Boolean(businessAccounts?.businessDetails?.[businessId]))
            .map((businessId) => {
              const user = businessAccounts?.businessDetails?.[businessId]
              return (
                <BusinessListItem
                  key={businessId}
                  id={businessId}
                  isAdmin
                  name={user?.name || ''}
                  avatar={resolveImageUrl(user?.profileImage, { width: 40 })}
                  onClick={handleOnSelection(businessId, true)}
                />
              )
            })}
        </div>
      </div>
    </Popup>
  )
}
